import React from 'react';

import { SpotlightPulse } from '@atlaskit/onboarding';
import { PopoverProvider, PopoverTarget } from '@atlaskit/spotlight';
import { fg } from '@confluence/feature-gating';

import { useDiscoverabilityPulse } from './useDiscoverabilityPulse.ts';

type DiscoverabilityPulseProps = {
	children: JSX.Element;
	entryPointId: string;
	isCircle?: boolean;
};

export const DiscoverabilityPulse = ({
	children,
	entryPointId,
	isCircle,
}: DiscoverabilityPulseProps) => {
	const { isPulseActive } = useDiscoverabilityPulse(entryPointId);

	if (!isPulseActive) {
		return children;
	}

	// Feature-gated migration from @atlaskit/onboarding to @atlaskit/spotlight
	if (fg('confluence_frontend_spotlight_ads_migration')) {
		return (
			<PopoverProvider>
				<PopoverTarget>{children}</PopoverTarget>
			</PopoverProvider>
		);
	}

	return (
		<SpotlightPulse radius={isCircle ? 24 : 3} testId="loom-cross-sell-discoverability-pulse">
			{children}
		</SpotlightPulse>
	);
};
